import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Container,
  TextField,
  Button,
  Box,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  MenuItem,
  Autocomplete,
  useMediaQuery,
  useTheme,
  Card,
  CardContent,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Divider } from "antd";
import AddItemForm from "../Inventory/ItemForm";
import {
  SalesOrderCreate,
  SalesOrderUpdate,
  getDivisionUnits,
  SalesOrderDetail,
  getUnits,
  getCategories,
  fetchSubCategories,
  fetchItemsByCategoryAndSubcategory,
  ApprovePartyList,
  GetNextSoNo,
} from "../../../Services/Services";
import { useCallback } from "react";
import { debounce } from "lodash";
import VisibilityIcon from "@mui/icons-material/Visibility";

export default function SalesOrderEntry() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile detection

 
  const [divisionList,setDivision]=useState([])
  const [partyOptions, setPartyOptions] = useState([]);
  const [partyPage, setPartyPage] = useState(1);
  const [partyLoading, setPartyLoading] = useState(false);
  const [partySearch, setPartySearch] = useState("");
  const [units, setUnits] = useState([]);
  const [file, setFile] = useState(null);
  const [openItemModal, setOpenItemModal] = useState();
  const [itemOptions, setItemOptions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [items, setItems] = useState({});
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const [existingFileName, setExistingFileName] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
    const getSelectedDivision = () => {
    try {
      const stored = localStorage.getItem("selectedDivision");
      return stored ? JSON.parse(stored) : null;
    } catch (e) {
      console.error("Failed to parse selectedDivision:", e);
      return null;
    }
  };
  const storedDivision = getSelectedDivision();

  const [formData, setFormData] = useState({
    division: storedDivision?.division_id || "",
    division_name:  "",
    party: "",
    project_name: "",
    order_date: "",
    so_no: "",
    project: "",
    po_number: "",
    created_by: localStorage.getItem("user_id"),
    cgst_per: 0,
    sgst_per: 0,
    round_off: 0,
    terms_and_conditions: [
      { key: "Delivery Period", value: "Within 15 days", is_default: true },
      { key: "Warranty", value: "12 months from delivery", is_default: true },
      { key: "Freight", value: "Included in price", is_default: true },
      { key: "Inspection", value: "By buyer at site", is_default: true },
      { key: "Quality", value: "As per specifications", is_default: true },
      {
        key: "Rejection/Claim",
        value: "Allowed within 7 days",
        is_default: true,
      },
      { key: "Jurisdiction", value: "Durg", is_default: true },
      {
        key: "Payment Terms",
        value: "50% advance, balance on delivery",
        is_default: true,
      },
      { key: "TCS/TDS", value: "As applicable", is_default: true },
      { key: "Remark", value: "None", is_default: true },
    ],
    items: [
      {
        category: "",
        
        item: "",
        description: "",
        quantity: 0,
        unit: "",
        rate: 0,
        amount: 0,
        dis_per: 0,
      },
    ],
    total_amount: 0,
    created_by: localStorage.getItem("user_id"),
    division: storedDivision?.division_id || "",
    cgst_per: 0,
    sgst_per: 0,
    round_off: 0,
  });
  const { id } = useParams();
  const isEditMode = !!id;

  const navigate = useNavigate();
  const fileInputRef = useRef();
  const location = useLocation();
  const orderData = location.state?.data;
  const amd = location.state?.amd;

  useEffect(() => {
    fetchDivionUnits();

    getCategories()
      .then((res) => {
        setCategories(Array.isArray(res) ? res : res?.results || []);
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
      });
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getParties(1, { name: partySearch });
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [partySearch]);

  useEffect(() => {
    if (!isEditMode) {
      fetchNextSoNo();
    }
  }, [isEditMode]);

  const fetchDivionUnits = async () => {
    const data = await getDivisionUnits();
    setUnits(data.units || []);
    setDivision(data.divisions)
  };

  const getParties = async (pageNum = 1, filters = {}) => {
    try {
      setPartyLoading(true);

      const response = await ApprovePartyList(pageNum, filters);
      const results = Array.isArray(response) ? response : [];

      if (pageNum === 1) {
        setPartyOptions(results);
      } else {
        setPartyOptions((prev) => [...prev, ...results]);
      }

      setPartyPage(pageNum);
    } catch (err) {
      console.error("Error fetching parties:", err);
      toast.error("Failed to load parties");
    } finally {
      setPartyLoading(false);
    }
  };

  const defaultTerms = [
    { key: "Delivery Period", value: "Within 15 days", is_default: true },
    { key: "Warranty", value: "12 months from delivery", is_default: true },
    { key: "Freight", value: "Included in price", is_default: true },
    { key: "Inspection", value: "By buyer at site", is_default: true },
    { key: "Quality", value: "As per specifications", is_default: true },
    {
      key: "Rejection/Claim",
      value: "Allowed within 7 days",
      is_default: true,
    },
    { key: "Jurisdiction", value: "Durg", is_default: true },
    {
      key: "Payment Terms",
      value: "50% advance, balance on delivery",
      is_default: true,
    },
    { key: "TCS/TDS", value: "As applicable", is_default: true },
    { key: "Remark", value: "None", is_default: true },
  ];

  useEffect(() => {
    const fetchOrder = async () => {
      if (id) {
        const response = await SalesOrderDetail(id);
        if (response) {
          const data = response;
          // const divisionData = divisionList.find((d) => d.division_id === data.division);

          if (data.project) {
            const fullPath = data.project.split("/").pop();
            const fileName = fullPath.split("?")[0];

            if (fileName.length > 20) {
              const ext = fileName.split(".").pop();
              const name = fileName.substring(0, 15);
              setExistingFileName(`${name}...${ext}`);
            } else {
              setExistingFileName(fileName);
            }
          }

          const mappedItems = (data.items || []).map((item) => ({
            category: {
              id: item.category || item.category?.id,
              name: item.category?.name || item.category_name || "",
            },
            // sub_category: {
            //   subcat_id: item.sub_category || item.sub_category?.subcat_id,
            //   name: item.sub_category?.name || item.sub_category_name || "",
            // },
            item: {
              id: item.item || item.item?.item || item.item || null,
              name: item.item?.name || item.item_name || "",
            },
            description: item.description || "",
            quantity: parseFloat(item.quantity) || 0,
            unit: item.unit || item.item?.unit || "",
            rate: parseFloat(item.rate) || 0,
            amount: parseFloat(item.amount) || 0,
            dis_per: parseFloat(item.dis_per) || 0,
          }));
          setFormData((prev) => ({
            ...prev,
            items: mappedItems,
          }));
          mappedItems.forEach(async (row, index) => {
            if (row.category?.id) {
              const subcatData = await fetchSubCategories(row.category.id);
              setSubcategories((prev) => {
                const updated = [...prev];
                updated[index] = subcatData;
                return updated;
              });
            }

            if (row.sub_category?.subcat_id) {
              const itemsData = await fetchItemsByCategoryAndSubcategory(
                row.category?.id,
                0,
              );

              setItems((prev) => ({
                ...prev,
                [index]: itemsData.results || itemsData,
              }));
            }
          });

          const parsedTerms = Array.isArray(data.terms_and_conditions)
            ? data.terms_and_conditions
            : JSON.parse(data.terms_and_conditions || "[]");

          setFormData({
            ...initialFormData,
            ...data,
            id: id,
            division: divisionList?.division || data.division || "",
            division_name: divisionList?.division || data.division_name || "",
            items: mappedItems,
            terms_and_conditions: parsedTerms,
          });

          setTermsAndConditions(parsedTerms);
        }
      }
    };

    fetchOrder();
  }, [id]);

  const initialFormData = {
    division:  "",
    division_name: "",
    party: "",
    project_name: "",
    order_date: "",
    project: "",
    terms_and_conditions: defaultTerms,
    items: [
      {
        category: "",
        
        item: "",
        description: "",
        quantity: 0,
        unit: "",
        rate: 0,
        amount: 0,
      },
    ],
    total_amount: 0,

    cgst_per: 0,
    sgst_per: 0,
    round_off: 0,
    grand_total: 0,
  };

  useEffect(() => {
    if (orderData && itemOptions.length > 0) {
      const normalizedItems = (orderData.items || []).map((item) => {
        const itemId = item.item?.id || item.item;
        const selectedItem = itemOptions.find((opt) => opt.id === itemId);

        return {
          item: item.id,
          category: selectedItem?.category || "",
          // sub_category: selectedItem?.sub_category || "",
          description: item.description || "",
          quantity: parseFloat(item.quantity) || 0,
          unit: item.unit || selectedItem?.unit || "",
          unit_name: selectedItem?.unit_name || "",
          rate: parseFloat(item.rate) || 0,
          amount: parseFloat(item.amount) || 0,
        };
      });

      let safeTerms = defaultTerms;

      if (Array.isArray(orderData.terms_and_conditions)) {
        safeTerms = orderData.terms_and_conditions;
      } else {
        try {
          const parsedTerms = JSON.parse(orderData.terms_and_conditions);
          if (Array.isArray(parsedTerms)) {
            safeTerms = parsedTerms;
          }
        } catch (e) {
          console.warn("Failed to parse terms_and_conditions", e);
        }
      }

      const newFormData = {
        ...initialFormData,
        ...orderData,
        id: id,
        items: normalizedItems,
        terms_and_conditions: safeTerms,
      };

      setFormData(newFormData);
      setTermsAndConditions(safeTerms);
    }
  }, [orderData, itemOptions]);

  const [termsAndConditions, setTermsAndConditions] = useState(
    formData.terms_and_conditions,
  );

  const fetchNextSoNo = async () => {
    const data = await GetNextSoNo();
    if (data && data.so_no) {
      setFormData((prev) => ({
        ...prev,
        so_no: data.so_no,
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const errors = {};
  if (!formData.email) {
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = "Enter a valid email address";
  }

  const handleItemChange = (e, index) => {
    const { name, value } = e.target;
    const items = [...formData.items];
    items[index][name] = value;

    if (name === "item") {
      const selected = itemOptions.find((opt) => String(opt.id) === value);
      items[index].unit = selected?.unit || "";
      items[index].unit_name = selected?.unit_name || "";
    }

    const qty = parseFloat(items[index].quantity) || 0;
    const rate = parseFloat(items[index].rate) || 0;
    const dis_per = parseFloat(items[index].dis_per) || 0;
    items[index].amount = qty * rate - (qty * rate * dis_per) / 100;

    const total_amount = items.reduce((sum, i) => sum + Number(i.amount), 0);
    const cgst_amt = (total_amount * (formData.cgst_per || 0)) / 100;
    const sgst_amt = (total_amount * (formData.sgst_per || 0)) / 100;
    const grand_total =
      total_amount + cgst_amt + sgst_amt + Number(formData.round_off || 0);
    setFormData((prev) => ({
      ...prev,
      items,
      total_amount: Number(total_amount.toFixed(2)),
      cgst_amt: Number(cgst_amt.toFixed(2)),
      sgst_amt: Number(sgst_amt.toFixed(2)),
      grand_total: Number(grand_total.toFixed(2)),
    }));
  };

  const addItem = () => {
    setFormData((prev) => ({
      ...prev,
      items: [
        ...prev.items,
        {
          category: "",
          
          item: "",
          description: "",
          quantity: 0,
          unit: "",
          rate: 0,
          amount: 0,
        },
      ],
    }));
  };

  const deleteItem = (index) => {
    const items = formData.items.filter((_, i) => i !== index);
    const total_amount = items.reduce((sum, i) => sum + Number(i.amount), 0);
    setFormData((prev) => ({ ...prev, items, total_amount }));
  };

  const handleTermChange = (index, field, value) => {
    const updatedTerms = [...termsAndConditions];
    updatedTerms[index][field] = value;
    setTermsAndConditions(updatedTerms);
  };

  const addTerm = () => {
    setTermsAndConditions([
      ...termsAndConditions,
      { key: "", value: "", is_default: false },
    ]);
  };

  const handleCloseItemModal = async () => {
    setOpenItemModal(false);
  };

  const removeTerm = (index) => {
    const updatedTerms = termsAndConditions.filter((_, i) => i !== index);
    setTermsAndConditions(updatedTerms);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // const divisionData = getSelectedDivision();
    // if (!divisionData?.division_id) {
    //   toast.error(
    //     "No division selected. Please select a division from the header.",
    //   );
    //   setLoading(false);
    //   return;
    // }

    // if (!formData.items || formData.items.length === 0) {
    //   toast.error("Please add at least one item before submitting.");
    //   setLoading(false);
    //   return;
    // }

    // const isInvalidItem = formData.items.some(
    //   (item) => !item.item || item.quantity <= 0,
    // );
    // if (isInvalidItem) {
    //   toast.error("Please add at least one item before submitting.");
    //   setLoading(false);
    //   return;
    // }

    const formDataToSend = new FormData();
    formDataToSend.append("project_name", formData.project_name);
    formDataToSend.append("party", formData.party);
    formDataToSend.append("division", formData.division);
    formDataToSend.append("order_date", formData.order_date);
    if (amd === "AMD") {
      if (!formData.so_no.endsWith("-AMD")) {
        formDataToSend.append("so_no", `${formData.so_no}-AMD`);
      } else {
        formDataToSend.append("so_no", formData.so_no);
      }
    } else {
      formDataToSend.append("so_no", formData.so_no);
    }
    formDataToSend.append("total_amount", formData.total_amount);
    formDataToSend.append("created_by", localStorage.getItem("user_id"));
    formDataToSend.append("division", formData.division);
    formDataToSend.append("cgst_per", formData.cgst_per);
    formDataToSend.append("sgst_per", formData.sgst_per);
    formDataToSend.append("round_off", formData.round_off);
    formDataToSend.append("grand_total", formData.grand_total || 0);
    formDataToSend.append("po_number", formData.po_number);

    if (file && file instanceof File) {
      formDataToSend.append("project", file);
    }

    const filteredTerms = termsAndConditions.filter(
      (term) => term.key.trim() !== "" && term.value.trim() !== "",
    );

    const cleanedItems = formData.items.map((item) => ({
      category: item.category?.id || item.category,
      // sub_category: item.sub_category?.subcat_id || item.sub_category,
      item: item.item?.id || item.item,
      description: item.description,
      quantity: item.quantity,
      unit: item.unit,
      rate: item.rate,
      dis_per: item.dis_per,
      amount: item.amount,
    }));

    formDataToSend.append(
      "terms_and_conditions",
      JSON.stringify(filteredTerms),
    );
    formDataToSend.append("items", JSON.stringify(cleanedItems));

    try {
      let result;
      if (id) {
        result = await SalesOrderUpdate(id, formDataToSend);
        toast.success("Sales Order Updated!");
      } else {
        result = await SalesOrderCreate(formDataToSend);
        toast.success("Sales Order Created!");
      }

      if (result) {
        resetForm();
        setTimeout(() => navigate("/dashboard/saleorderlist"), 1000);
      } else {
        toast.error("Something went wrong.");
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Failed to submit Sales Order.");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    sessionStorage.removeItem("soDraftHeader");
   
    setTermsAndConditions(defaultTerms);
    setFile(null);
    if (fileInputRef.current) fileInputRef.current.value = null;
    setTimeout(() => navigate("/dashboard/saleorderlist"), 1000);
  };

  const handleItemAutocompleteChange = async (index, key, value) => {
    const updatedItems = [...formData.items];
    let row = updatedItems[index];
    switch (key) {
      // case "category":
      //   row = { ...row, category: value, sub_category: null, item: null };
      //   if (value) {
      //     const subcats = await fetchSubCategories(value.id, page, searchTerm);
      //     const subs = [...subcategories];
      //     subs[index] = subcats;
      //     setSubcategories(subs);
      //   }
      //   break;

      case "category":
        row = { ...row, category: value, item: null };
        if (value) {
          const itemData = await fetchItemsByCategoryAndSubcategory(
            value.id,
           0,
            page,
            searchTerm,
          );
          const mappedItems = (itemData.results || []).map((item) => ({
            id: item.id,
            name: item.name,
          }));

          setItems((prev) => ({
            ...prev,
            [index]: mappedItems,
          }));
        }
        break;

      case "item":
        row = {
          ...row,
          item: value,
          uom: value?.unit_name || "",
          description: value?.description || "",
          stock_qty: value?.current_stock || "",
        };
        const qty = parseFloat(row.quantity) || 0;
        const price = parseFloat(row.rate) || 0;
        const dis_per = parseFloat(row.dis_per) || 0;
        row.amount = qty * price - (qty * price * dis_per) / 100;
        break;
    }
    updatedItems[index] = row;
    const total_amount = updatedItems.reduce(
      (sum, item) => sum + Number(item.amount),
      0,
    );
    setFormData((prev) => ({
      ...prev,
      items: updatedItems,
      total_amount,
    }));
  };

  const handleItemInputChange = useCallback(
    debounce(async (index, row, newValue, type) => {
      if (!newValue || newValue.trim() === "") {
        if (type === "category") {
          const catData = await getCategories();
          const list = Array.isArray(catData.results)
            ? catData.results
            : catData;
          setCategories(list);
        }

        if (type === "sub_category" && row.category) {
          const subcatData = await fetchSubCategories(row.category.id);
          setSubcategories((prev) => {
            const updated = [...prev];
            updated[index] = subcatData;
            return updated;
          });
        }
        if (type === "item" && row.category) {
          const itemData = await fetchItemsByCategoryAndSubcategory(
            row.category.id,
           0,
          );
          setItems((prev) => ({
            ...prev,
            [index]: itemData.results || [],
          }));
        }
        return;
      }
      if (type === "category") {
        const catData = await getCategories(1, newValue || "");
        const list = Array.isArray(catData.results) ? catData.results : catData;

        setCategories(list);
      }
      if (!row.category) return;
      if (type === "sub_category" && row.category) {
        const subcatData = await fetchSubCategories(
          row.category.id,
          1,
          newValue || "",
        );
        setSubcategories((prev) => {
          const updated = [...prev];
          updated[index] = subcatData;
          return updated;
        });
      }
      if (type === "item" && row.category ) {
        const itemData = await fetchItemsByCategoryAndSubcategory(
          row.category.id,
          0,
          1,
          newValue || "",
        );

        const mappedItems = (itemData.results || []).map((item) => ({
          id: item.id,
          name: item.name,
        }));

        setItems((prev) => ({
          ...prev,
          [index]: mappedItems,
        }));
      }
    }, 500),
    [],
  );

  const handleSaveDraft = () => {
    sessionStorage.setItem("soDraftHeader", JSON.stringify(formData));
    toast.info("Sales Order draft saved!");
  };

  useEffect(() => {
    const draftHeader = sessionStorage.getItem("soDraftHeader");
    if (draftHeader) {
      try {
        const parsed = JSON.parse(draftHeader);
        setFormData(parsed);
        toast.info("Loaded Sales Order draft");
      } catch (e) {
        console.error("Failed to parse draft:", e);
      }
    }
  }, []);

  return (
    <Container maxWidth="xl">
      <ToastContainer />

      {/* ✅ BUTTONS SABSE UPAR - Desktop same position, Mobile stack at top */}
      {isMobile && (
        <Grid container spacing={2} sx={{ mb: 2, mt:{xs:2,sm:2} }}>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              onClick={handleSaveDraft}
              sx={{
                borderRadius: 0,
                height: 35,
                fontSize: "0.7rem",
                color: "#ff8400ff",
                borderColor: "#ff8400ff",
              }}
            >
              Draft
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
              onClick={handleSubmit}
              sx={{ borderRadius: 0, height: 35, fontSize: "0.7rem" }}
            >
              {loading ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          </Grid>
        </Grid>
      )}
      <form onSubmit={handleSubmit} autoComplete="off">
        <Box p={-2} m={-2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="SO No."
                name="so_no"
                value={formData.so_no || ""}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="PO number"
                name="po_number"
                value={formData.po_number}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                type="date"
                name="order_date"
                label="PO Date"
                value={formData.order_date}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                required
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                }}
              />
            </Grid>

            {/* Desktop buttons inline */}
            {!isMobile && (
              <Grid item xs={12} sm={3} sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleSaveDraft}
                  sx={{
                    borderRadius: 0,
                    fontSize: "0.7rem",
                    color: "#ff8400ff",
                    borderColor: "#ff8400ff",
                  }}
                >
                  Draft
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  sx={{ borderRadius: 0, fontSize: "0.7rem" }}
                >
                  {loading ? (
                    <CircularProgress size={22} color="inherit" />
                  ) : (
                    "Submit Sales Order"
                  )}
                </Button>
              </Grid>
            )}

        
            {/* <Grid item xs={12} sm={3}>
              <Autocomplete
                options={divisionList}
                getOptionLabel={(option) => option.division || ""}
                value={
                  divisionList.find((option) => option.division_id === formData.division) ||
                  null
                }
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    division: newValue ? newValue.division_id : "",
                  }));
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason === "input") setPartySearch(newInputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      style: {
                        height: "11px",
                      },
                    }}
                    label="Division"
                    required
                  />
                )}
              />
            </Grid> */}
            <Grid item xs={12} sm={3}>
              <Autocomplete
                options={partyOptions}
                getOptionLabel={(option) => option.company_name || ""}
                value={
                  partyOptions.find((option) => option.id === formData.party) ||
                  null
                }
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    party: newValue ? newValue.id : "",
                  }));
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason === "input") setPartySearch(newInputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      style: {
                        height: "11px",
                      },
                    }}
                    label="Debtor"
                    required
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Project"
                name="project_name"
                value={formData.project_name}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Box>
                <TextField
                  fullWidth
                  type="file"
                  name="project"
                  onChange={(e) => {
                    setFile?.(e.target.files?.[0] || null);
                    setExistingFileName(""); // ✅ Clear filename when new file selected
                  }}
                  inputRef={fileInputRef}
                  InputLabelProps={{ shrink: true }}
                  label={
                    existingFileName
                      ? "Change Project File"
                      : "Upload Project File"
                  }
                  variant="outlined"
                  error={Boolean(errors.project_file)}
                  inputProps={{
                    accept: "*/*",
                  }}
                />

                {/* ✅ Show existing file info */}
                {existingFileName && formData.project && isEditMode && (
                  <Box
                    mt={0.5}
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{ fontSize: "0.75rem", color: "text.secondary" }}
                  >
                    <span>Current: {existingFileName}</span>
                    <IconButton
                      size="small"
                      onClick={() => window.open(formData.project, "_blank")}
                    >
                      <VisibilityIcon fontSize="small" color="primary" />
                    </IconButton>
                  </Box>
                )}

                {errors.project_file && (
                  <Box
                    sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}
                  >
                    {errors.project_file}
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>

          <Divider />

          {/* ✅ TABLE SECTION - Desktop same, Mobile card layout */}
          {isMobile ? (
            // Mobile Card Layout
            <Box sx={{ mb: 2 }}>
              {formData.items.map((item, index) => (
                <Card key={index} sx={{ mb: 2, border: "1px solid #ddd" }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Item #{index + 1}
                    </Typography>

                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                    >
                      <Autocomplete
                        options={categories}
                        getOptionLabel={(opt) => opt.name}
                        value={item.category || null}
                        onChange={async (e, val, reason) => {
                          if (reason === "clear" || !val) {
                            await handleItemInputChange(
                              index,
                              item,
                              "",
                              "category",
                            );
                            handleItemAutocompleteChange(
                              index,
                              "category",
                              null,
                            );
                            return;
                          }
                          handleItemAutocompleteChange(index, "category", val);
                        }}
                        onInputChange={(e, newValue, reason) => {
                          if (reason === "input") {
                            handleItemInputChange(
                              index,
                              item,
                              newValue,
                              "category",
                            );
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Category"
                            // required
                            size="small"
                          />
                        )}
                      />

                      {/* <Autocomplete
                        options={subcategories[index] || []}
                        getOptionLabel={(opt) => opt.name}
                        value={
                          (subcategories[index] || []).find(
                            (s) => s.subcat_id === item.sub_category?.subcat_id,
                          ) || null
                        }
                        onChange={async (e, val, reason) => {
                          if (reason === "clear" || !val) {
                            await handleItemInputChange(
                              index,
                              item,
                              "",
                              "sub_category",
                            );
                            handleItemAutocompleteChange(
                              index,
                              "sub_category",
                              null,
                            );
                            return;
                          }
                          handleItemAutocompleteChange(
                            index,
                            "sub_category",
                            val,
                          );
                        }}
                        onInputChange={(e, newValue) =>
                          handleItemInputChange(
                            index,
                            item,
                            newValue,
                            "sub_category",
                          )
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Subcategory"
                            required
                            size="small"
                          />
                        )}
                      /> */}

                      <Autocomplete
                        options={items[index] || []}
                        getOptionLabel={(opt) => opt.name || ""}
                        value={item.item || null}
                        onChange={async (e, val, reason) => {
                          if (reason === "clear" || !val) {
                            await handleItemInputChange(
                              index,
                              item,
                              "",
                              "item",
                            );
                            handleItemAutocompleteChange(index, "item", null);
                            return;
                          }
                          handleItemAutocompleteChange(index, "item", val);
                        }}
                        onInputChange={(e, newValue) =>
                          handleItemInputChange(index, item, newValue, "item")
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Item"
                            // required
                            size="small"
                          />
                        )}
                      />

                      <TextField
                        fullWidth
                        label="Description"
                        name="description"
                        value={item.description}
                        onChange={(e) => handleItemChange(e, index)}
                        size="small"
                      />

                      <Autocomplete
                        options={units}
                        getOptionLabel={(option) => option.name}
                        value={units.find((u) => u.id === item.unit) || null}
                        onChange={(e, newVal) => {
                          const items = [...formData.items];
                          items[index].unit = newVal?.id || "";
                          setFormData((prev) => ({ ...prev, items }));
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Unit"
                            // required
                            size="small"
                          />
                        )}
                      />

                      <TextField
                        fullWidth
                        label="Qty"
                        type="number"
                        name="quantity"
                        value={item.quantity}
                        onChange={(e) => handleItemChange(e, index)}
                        size="small"
                      />

                      <TextField
                        fullWidth
                        label="Rate"
                        type="number"
                        name="rate"
                        value={item.rate}
                        onChange={(e) => handleItemChange(e, index)}
                        size="small"
                      />

                      <TextField
                        fullWidth
                        label="Disc (%)"
                        type="number"
                        name="dis_per"
                        value={item.dis_per}
                        onChange={(e) => handleItemChange(e, index)}
                        size="small"
                      />

                      <TextField
                        fullWidth
                        label="Total"
                        value={item.amount}
                        size="small"
                        disabled
                      />

                      <Button
                        fullWidth
                        variant="outlined"
                        color="error"
                        onClick={() => deleteItem(index)}
                        startIcon={<DeleteIcon />}
                      >
                        Delete Item
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              ))}
              <Button
                variant="outlined"
                onClick={addItem}
                startIcon={<AddIcon />}
                fullWidth
              >
                Add Item
              </Button>
            </Box>
          ) : (
            // Desktop Table (Original)
            <>
              <TableContainer
                component={Paper}
                sx={{
                  mb: 2,
                  overflowX: "auto",
                }}
              >
                <Box sx={{ minWidth: 1800 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow
                        sx={{
                          backgroundColor: "#f5f5f5",
                          "& th": {
                            fontWeight: "bold",
                            color: "#333",
                            borderBottom: "1px solid #999",
                            backgroundColor: "#f5f5f5",
                          },
                        }}
                      >
                        <TableCell>Category</TableCell>
                        {/* <TableCell>Sub Category</TableCell> */}
                        <TableCell>Item</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell sx={{ width: "80px" }}>Unit</TableCell>
                        <TableCell>Qty</TableCell>
                        <TableCell>Rate</TableCell>
                        <TableCell>Disc (%)</TableCell>
                        <TableCell>Total</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {formData.items.map((item, index) => {
                        const selectedItem = itemOptions.find(
                          (opt) => opt.id === item.item,
                        );
                        return (
                          <TableRow
                            key={index}
                            hover={false}
                            sx={{
                              backgroundColor: "#fff !important",
                              "&:hover": {
                                backgroundColor: "#fff !important",
                              },
                            }}
                          >
                            <TableCell>
                              <Autocomplete
                                options={categories}
                                getOptionLabel={(opt) => opt.name}
                                value={item.category || null}
                                onChange={async (e, val, reason) => {
                                  if (reason === "clear" || !val) {
                                    await handleItemInputChange(
                                      index,
                                      item,
                                      "",
                                      "category",
                                    );
                                    handleItemAutocompleteChange(
                                      index,
                                      "category",
                                      null,
                                    );
                                    return;
                                  }
                                  handleItemAutocompleteChange(
                                    index,
                                    "category",
                                    val,
                                  );
                                }}
                                onInputChange={(e, newValue, reason) => {
                                  if (reason === "input") {
                                    handleItemInputChange(
                                      index,
                                      item,
                                      newValue,
                                      "category",
                                    );
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    inputProps={{
                                      ...params.inputProps,
                                      style: {
                                        height: "10px",
                                      },
                                    }}
                                    label="Category"
                                    // required
                                  />
                                )}
                              />
                            </TableCell>

                            {/* <TableCell>
                              <Autocomplete
                                options={subcategories[index] || []}
                                getOptionLabel={(opt) => opt.name}
                                value={
                                  (subcategories[index] || []).find(
                                    (s) =>
                                      s.subcat_id ===
                                      item.sub_category?.subcat_id,
                                  ) || null
                                }
                                onChange={async (e, val, reason) => {
                                  if (reason === "clear" || !val) {
                                    await handleItemInputChange(
                                      index,
                                      item,
                                      "",
                                      "sub_category",
                                    );
                                    handleItemAutocompleteChange(
                                      index,
                                      "sub_category",
                                      null,
                                    );
                                    return;
                                  }
                                  handleItemAutocompleteChange(
                                    index,
                                    "sub_category",
                                    val,
                                  );
                                }}
                                onInputChange={(e, newValue) =>
                                  handleItemInputChange(
                                    index,
                                    item,
                                    newValue,
                                    "sub_category",
                                  )
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    inputProps={{
                                      ...params.inputProps,
                                      style: {
                                        height: "10px",
                                      },
                                    }}
                                    label="Subcategory"
                                    required
                                  />
                                )}
                              />
                            </TableCell> */}

                            <TableCell>
                              <Autocomplete
                                options={items[index] || []}
                                getOptionLabel={(opt) => opt.name || ""}
                                value={item.item || null}
                                onChange={async (e, val, reason) => {
                                  if (reason === "clear" || !val) {
                                    await handleItemInputChange(
                                      index,
                                      item,
                                      "",
                                      "item",
                                    );
                                    handleItemAutocompleteChange(
                                      index,
                                      "item",
                                      null,
                                    );
                                    return;
                                  }
                                  handleItemAutocompleteChange(
                                    index,
                                    "item",
                                    val,
                                  );
                                }}
                                onInputChange={(e, newValue) =>
                                  handleItemInputChange(
                                    index,
                                    item,
                                    newValue,
                                    "item",
                                  )
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Item"
                                    inputProps={{
                                      ...params.inputProps,
                                      style: {
                                        height: "10px",
                                      },
                                    }}
                                    // required
                                  />
                                )}
                              />
                            </TableCell>

                            <TableCell sx={{ width: "200px" }}>
                              <TextField
                                fullWidth
                                name="description"
                                value={item.description}
                                onChange={(e) => handleItemChange(e, index)}
                              />
                            </TableCell>

                            <TableCell sx={{ width: "150px" }}>
                              <Grid item minWidth={150}>
                                <Autocomplete
                                  options={units}
                                  getOptionLabel={(option) => option.name}
                                  value={
                                    units.find((u) => u.id === item.unit) ||
                                    null
                                  }
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: 45,
                                      paddingRight: "8px",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      padding: "10px 14px",
                                    },
                                  }}
                                  onChange={(e, newVal) => {
                                    const items = [...formData.items];
                                    items[index].unit = newVal?.id || "";
                                    setFormData((prev) => ({ ...prev, items }));
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Unit"
                                      // required
                                    />
                                  )}
                                />
                              </Grid>
                            </TableCell>
                            <TableCell sx={{ width: "150px" }}>
                              <TextField
                                fullWidth
                                type="number"
                                name="quantity"
                                value={item.quantity}
                                onChange={(e) => handleItemChange(e, index)}
                              />
                            </TableCell>
                            <TableCell sx={{ width: "150px" }}>
                              <TextField
                                fullWidth
                                type="number"
                                name="rate"
                                value={item.rate}
                                onChange={(e) => handleItemChange(e, index)}
                              />
                            </TableCell>
                            <TableCell sx={{ width: "150px" }}>
                              <TextField
                                fullWidth
                                type="number"
                                name="dis_per"
                                value={item.dis_per}
                                onChange={(e) => handleItemChange(e, index)}
                              />
                            </TableCell>

                            <TableCell sx={{ width: "150px" }}>
                              <TextField fullWidth value={item.amount} />
                            </TableCell>

                            <TableCell>
                              <IconButton
                                onClick={() => deleteItem(index)}
                                color="error"
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Button
                variant="outlined"
                onClick={addItem}
                startIcon={<AddIcon />}
              >
                Add Item
              </Button>
            </>
          )}

          {/* Total Section - Both Mobile & Desktop */}
          <TableContainer
            component={Paper}
            sx={{ ml: "auto", mb: 2, backgroundColor: "#FCFCFC" }}
          >
            <Table size="small">
              <TableBody>
                <Grid container justifyContent="flex-end" mt={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <TableRow>
                      <TableCell colSpan={6} align="right">
                        <strong>Sub Total</strong>
                      </TableCell>
                      <TableCell colSpan={2}>
                        <TextField
                          value={formData.total_amount}
                          fullWidth
                          sx={{ maxWidth: 120 }}
                          disabled
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={6} align="right">
                        <b>CGST + SGST (%)</b>
                      </TableCell>
                      <TableCell colSpan={2}>
                        <TextField
                          fullWidth
                          sx={{ maxWidth: 120 }}
                          type="number"
                          value={formData.cgst_per || 0}
                          onChange={(e) => {
                            const cgst_per = parseFloat(e.target.value) || 0;
                            const cgst_amt =
                              (formData.total_amount * cgst_per) / 100;
                            const sgst_amt =
                              (formData.total_amount *
                                (formData.sgst_per || 0)) /
                              100;
                            const grand_total =
                              formData.total_amount +
                              cgst_amt +
                              sgst_amt +
                              Number(formData.round_off || 0);
                            setFormData((prev) => ({
                              ...prev,
                              cgst_per,
                              grand_total,
                            }));
                          }}
                        />
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell colSpan={6} align="right">
                        <b>IGST (%)</b>
                      </TableCell>
                      <TableCell colSpan={2}>
                        <TextField
                          fullWidth
                          sx={{ maxWidth: 120 }}
                          type="number"
                          value={formData.sgst_per || 0}
                          onChange={(e) => {
                            const sgst_per = parseFloat(e.target.value) || 0;
                            const cgst_amt =
                              (formData.total_amount *
                                (formData.cgst_per || 0)) /
                              100;
                            const sgst_amt =
                              (formData.total_amount * sgst_per) / 100;
                            const grand_total =
                              formData.total_amount +
                              cgst_amt +
                              sgst_amt +
                              Number(formData.round_off || 0);
                            setFormData((prev) => ({
                              ...prev,
                              sgst_per,
                              grand_total,
                            }));
                          }}
                        />
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell colSpan={6} align="right">
                        <b>Round Off</b>
                      </TableCell>
                      <TableCell colSpan={2}>
                        <TextField
                          fullWidth
                          sx={{ maxWidth: 120 }}
                          type="number"
                          value={formData.round_off || 0}
                          onChange={(e) => {
                            const round_off = parseFloat(e.target.value) || 0;
                            const cgst_amt =
                              (formData.total_amount *
                                (formData.cgst_per || 0)) /
                              100;
                            const sgst_amt =
                              (formData.total_amount *
                                (formData.sgst_per || 0)) /
                              100;
                            const grand_total =
                              formData.total_amount +
                              cgst_amt +
                              sgst_amt +
                              round_off;
                            setFormData((prev) => ({
                              ...prev,
                              round_off,
                              grand_total,
                            }));
                          }}
                        />
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell colSpan={6} align="right">
                        <strong>Grand Total</strong>
                      </TableCell>
                      <TableCell colSpan={2}>
                        <TextField
                          fullWidth
                          sx={{ maxWidth: 120 }}
                          disabled
                          value={formData.grand_total}
                        />
                      </TableCell>
                    </TableRow>
                  </Grid>
                </Grid>
              </TableBody>
            </Table>
          </TableContainer>

          <Divider />

          {/* Terms and Conditions */}
          <Box mt={2}>
            <Typography
              variant={isMobile ? "subtitle1" : "h6"}
              fontWeight="bold"
              mb={2}
            >
              Terms & Conditions
            </Typography>

            {termsAndConditions.map((term, index) => (
              <Grid
                container
                spacing={1}
                key={index}
                alignItems="center"
                mb={1}
                wrap="nowrap" // ✅ Yeh important hai - line break nahi hoga
              >
                <Grid item xs={3} sm={3}>
                  <TextField
                    fullWidth
                    size="small"
                    value={term.key}
                    onChange={(e) =>
                      handleTermChange(index, "key", e.target.value)
                    }
                    placeholder="Term"
                  />
                </Grid>
                <Grid item xs={7} sm={8}>
                  <TextField
                    fullWidth
                    size="small"
                    value={term.value}
                    onChange={(e) =>
                      handleTermChange(index, "value", e.target.value)
                    }
                    placeholder="Value"
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  sm={1}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <IconButton
                    onClick={() => removeTerm(index)}
                    color="error"
                    size="small"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Grid>
              </Grid>
            ))}

            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={addTerm}
              sx={{ mt: 1 }}
              size={isMobile ? "small" : "medium"}
            >
              Add More Terms
            </Button>
          </Box>

          {/* Bottom spacing for mobile */}
          {isMobile && <Box sx={{ height: 30 }} />}
        </Box>
      </form>
      <Dialog
        open={openItemModal}
        onClose={handleCloseItemModal}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Add Item</DialogTitle>
        <DialogContent>
          <AddItemForm onClose={handleCloseItemModal} />
        </DialogContent>
      </Dialog>
    </Container>
  );
}
